// extracted by mini-css-extract-plugin
export default {"calendarChipContainer":"AddCalendar_calendarChipContainer__pJelk","calendarChip":"AddCalendar_calendarChip__hdgjC","calendarSkeletonChip":"AddCalendar_calendarSkeletonChip__JQztm"};